/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { SuppliersService } from '@app/suppliers/suppliers/suppliers.service';
import { SuppliersFormService } from '@app/suppliers/suppliers/suppliers-form.service';
import { Supplier } from '@app/suppliers/suppliers/suppliers.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';

const log = new Logger('suppliersListComponent');

@Component({
  selector: 'app-suppliers-list',
  templateUrl: './suppliers-list.component.html',
  styleUrls: ['./suppliers-list.component.scss'],
})
export class SuppliersListComponent extends KendoGridComponent implements OnInit {
  suppliersResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  @ViewChild('grid', { static: true }) grid: any;

  UserRoleType = UserRoleType;

  constructor(
    private supplierService: SuppliersService,
    private suppliersFormService: SuppliersFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('SuppliersListComponent');
    this.loadData(this.state);
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery
      .setDataSetFilters(state)
      .addIncludes('type', 'companies.pivot.properties.type', 'companies.pivot.contact_persons.title', 'contacts.type');

    this.supplierService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.suppliersResponse = response;
      this.data = response.getGridData();

      // expand all grid rows
      // response.data.forEach((item, idx) => {
      //   this.grid.expandRow(idx);
      // });
    });
    CustomKendoFilter.pushStateInStorage('SuppliersListComponent', this.state);
  }

  add() {
    this.suppliersFormService.open().then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info(err);
      }
    );
  }

  /**
   *
   * @param supplier Supplier object
   */
  edit(supplier: Supplier) {
    this.suppliersFormService.open(supplier).then(
      () => {
        this.loadData();
      },
      (res: any) => {
        log.info(res);
      }
    );
  }

  /**
   *
   * @param supplier Supplier object
   */
  delete(supplier: Supplier) {
    this.supplierService.destroy(supplier.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  /**
   * @todo това е само пример!!!
   */
  export() {
    this.supplierService.export(this.apiQuery);
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
